module.exports = "<ion-content>\n\tproperty detail guest page\n</ion-content>"